import Messaging from '../../OnePageGivingMessaging';

/** @typedef {import('../../types').ResponseHandler} ResponseHandler */
/** @typedef {import('../../types').ErrorResponse} ErrorResponse */


/**
 * @type {ResponseHandler}
 * @param {ErrorResponse} response
 */
const handle = async (response, recaptcha) => {
  if (response.recaptchaValidated) {
    recaptcha.reset();
  }

  Messaging.addPageError(response.message);
};


export default {
  handle,
};



// WEBPACK FOOTER //
// ./src/onePageGiving/hostedPayment/responseHandlers/ErrorResponseHandler.js